import {
  Box,
  Typography,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Button,
  Paper,
  Grid,
} from "@mui/material";
import TimerIcon from "@mui/icons-material/Timer";
import VideocamIcon from "@mui/icons-material/Videocam";
import BlockIcon from "@mui/icons-material/Block";
import AssignmentIcon from "@mui/icons-material/Assignment";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import CloseFullscreenIcon from "@mui/icons-material/CloseFullscreen"; // New icon for switching tabs
import ReportGmailerrorredIcon from "@mui/icons-material/ReportGmailerrorred"; // New icon for illegal activity
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";

const Instruction = () => {
  const navigate = useNavigate();
useEffect(() =>{
  localStorage.removeItem("fullscreen")
})
  const instructions = [
    {
      icon: <TimerIcon color="primary" />,
      text: "Assessment duration is 30 minutes.",
    },
    {
      icon: <VideocamIcon color="primary" />,
      text: "Webcam must remain ON throughout the test.",
    },
    {
      icon: <BlockIcon color="primary" />,
      text: "Do not switch tabs or open other applications during the test.",
    },
    {
      icon: <CloseFullscreenIcon color="error" />,
      text: "Switching tabs will automatically submit the test.",
    },
    {
      icon: <AssignmentIcon color="primary" />,
      text: "Read each question carefully before answering.",
    },
    {
      icon: <ReportGmailerrorredIcon color="error" />,
      text: "Any illegal activity or malpractice will lead to immediate disqualification.",
    },
  ];

  return (
    <Box minHeight="100vh">
      <Grid
        item
        sx={{
          display: "flex",
          alignItems: "center",
          color: "#1c97e3",
          gap: "4px",
          cursor: "pointer",
          width: "40px",
          marginBottom: "20px",
        }}
        onClick={() => navigate(-1)}
      >
        <ArrowBackIcon sx={{ fontSize: "17px" }} />
        <Typography sx={{ fontWeight: 600, fontSize: "14px", color: "#1c97e3" }}>
          Back
        </Typography>
      </Grid>
      <Box display="flex" justifyContent="center" alignItems="center">
        <Paper
          elevation={4}
          sx={{ p: 4, borderRadius: 3, maxWidth: 600, width: "100%" }}
        >
          <Typography
            variant="h4"
            align="center"
            gutterBottom
            sx={{ fontWeight: "bold", color: "#1c97e3" }}
          >
            Online Interview Instructions
          </Typography>

          <List>
            {instructions.map((item, index) => (
              <ListItem key={index}>
                <ListItemIcon>{item.icon}</ListItemIcon>
                <ListItemText primary={item.text} />
              </ListItem>
            ))}
          </List>

          <Box
            textAlign="center"
            mt={3}
            onClick={() =>
              navigate("/test", {
                state: {
                  login: true,
                },
              })
            }
          >
            <Button
              variant="contained"
              size="large"
              sx={{
                borderRadius: "30px",
                px: 5,
                backgroundColor: "#1c97e3",
                "&:hover": { backgroundColor: "#1565c0" },
              }}
            >
              Start Test
            </Button>
          </Box>
        </Paper>
      </Box>
    </Box>
  );
};

export default Instruction;
